const inlineFilterItems = [
  {
    id: 'all',
    label: 'Semua',
  },
  {
    id: 'DRAFT',
    label: 'Draf',
  },
  {
    id: 'ACTIVE',
    label: 'Aktif',
  },
  {
    id: 'EXPIRED',
    label: 'Kadaluwarsa',
  },
  {
    id: 'INACTIVE',
    label: 'Non Aktif',
  },
]

export default inlineFilterItems
